import DoAPICall from "./DoAPICall";

// Create promotionrates ('C' in CRUD)
export async function createPromotionRate(userToken, promotionrates) {
  const apiPayload = {
    httpMethod: "post",
    userToken,
    uri: "promotionrates",
    payLoad: {
      promotion_id: promotionrates.promotion_id,
      band: promotionrates.band,
      minAmount: promotionrates.minAmount,
      maxAmount: promotionrates.maxAmount,
      rate: promotionrates.rate,
      name: promotionrates.name
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// 'promotion_id','','', '','',''

// Get All promotionrates ('R' in CRUD)
export async function getPromotionRates(userToken) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionrates",
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get one promotionrates by ID ('R' in CRUD)
export async function getPromotionRate(userToken, id) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionrates/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Get rates  of a promotions
export async function getRatesOfPromotion(userToken, promotion_id) {
  const apiPayload = {
    httpMethod: "get",
    userToken,
    uri: "promotionrates/" + promotion_id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Update promotionrates ('U' in CRUD)
export async function updatePromotionRate(userToken, promotionrates) {
  const apiPayload = {
    httpMethod: "put",
    userToken,
    uri: "promotionrates/" + promotionrates.id,
    payLoad: {
      promotion_id: promotionrates.promotion_id,
      band: promotionrates.band,
      minAmount: promotionrates.minAmount,
      maxAmount: promotionrates.maxAmount,
      rate: promotionrates.rate,
      name: promotionrates.name
    },
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}

// Delete promotionrates ('D' in CRUD)
export async function deletePromotionRate(userToken, id) {
  const apiPayload = {
    httpMethod: "delete",
    userToken,
    uri: "promotionrates/" + id,
    payLoad: {},
    requestOptions: {},
  };
  return await DoAPICall(apiPayload);
}
